import BaseService from 'services/BaseService';

export default class TransactionLinkService extends BaseService {
	_type = 'transactionLink';
	_typeKey = 'link_type';
}
